import { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import Sidebar from "../../../Sidebar/Sidebar";
import { useBorrowerContext } from "../BorrowerDetails/store/borrower-details";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useNavigate } from "react-router-dom";

const ViewPersonalDetailsScreen = () => {
  const { borrowerData } = useBorrowerContext();
  const borrower = borrowerData?.borrower || {};
  const [open, setOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const openView = (val) => setIsOpen(val);
  console.log(setOpen);
  const navigate = useNavigate();
  
  const getBorrowerFullName = () => {
    return `${borrower.borrower_firstname || ""} ${
      borrower.borrower_middlename || ""
    } ${borrower.borrower_lastname || ""}`.trim() || "Borrower";
  };
  const borrowerFullName = getBorrowerFullName();
  const borrowerFirstName = borrower.borrower_firstname || "the borrower";

  const formatDate = (dateString) => {
  if (!dateString) return "-";

  const date = new Date(dateString);
  if (isNaN(date)) return "-";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};


  return (
    <div className="min-h-screen bg-[#EDF5FF] flex"> 
      <Sidebar click={openView} />

      <div
        className={`flex-1 transition-all duration-300 ${
          isOpen ? "ml-[15%]" : "ml-0"
        }`}
      >
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        <div className="min-h-screen px-10 py-8">
          {/* BACK BUTTON */}
          <div className="w-full max-w-[90rem] mt-20 flex items-center gap-2">
            <ChevronLeftIcon className="w-5 h-5 text-blue-600" />
            <button
              onClick={() => navigate(`/single/borrower/details/${borrower.borrower_uniqueno}`)}
              className="text-blue-600 text-sm no-underline hover:no-underline"
            >
              Back to Borrower Details
            </button>
          </div>

          <div className="bg-white shadow-md p-6 mb-6 mt-4">
            <h1 className="text-xl font-bold text-gray-800">
              Personal Details for {borrowerFullName.toUpperCase()}
            </h1>
            <p className="text-gray-500 text-base mt-1">
              Overview of {borrowerFirstName}’s personal information.
            </p>
          </div>

          <div className="bg-white shadow-md p-8">
            <h2 className="text-xl font-bold text-gray-800 pb-4 mb-4 border-b border-gray-200">
              Borrower Information
            </h2>
            <div className=""> 
              {[
                ["Title", borrower.borrower_title],
                ["Gender", borrower.borrower_gender],
                ["First Name", borrower.borrower_firstname],
                ["Middle Name", borrower.borrower_middlename],
                ["Last Name", borrower.borrower_lastname],
                ["Date Of Birth", formatDate(borrower.borrower_dob)],
                ["Educational Qualification", borrower.borrower_education],
                ["Father Name", borrower.borrower_fathername],
                ["Mother's Maiden Name", borrower.borrower_mother_maiden],
                ["Mother Tongue", borrower.borrower_motherTongue],
                ["Category", borrower.borrower_category],
                ["Religion", borrower.borrower_religion],
                ["Voter ID", borrower.borrower_voter_no],
              ].map(([label, value], idx) => (
                <div
                  key={idx}
                  className="flex justify-between items-center py-2 border-b border-gray-200 last:border-b-0 text-base"
                >
                  <span className="text-gray-600 w-1/3">
                    {label}:
                  </span>
                  <span className="text-gray-900 w-2/3">
                    {value || "-"}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewPersonalDetailsScreen;